// extracted by mini-css-extract-plugin
module.exports = {"bannerShelf":"BannerShelf-bannerShelf-3SVl1F","bannerTab":"BannerShelf-bannerTab-1eEsL1"};